'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createResult = function createResult() {
  var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return Object.assign([result, error], {
    result: result,
    error: error
  });
};

var isExpectedError = function isExpectedError(actual, expects) {
  if (expects.length === 0) return true;
  return expects.some(function (E) {
    return actual instanceof E;
  });
};

var rescue = function rescue(proc) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$expects = _ref.expects,
      expects = _ref$expects === void 0 ? [] : _ref$expects;

  try {
    var result = proc();

    if (result instanceof Promise) {
      return new Promise(function (resolve) {
        result.then(function (r) {
          resolve(createResult(r));
        })["catch"](function (e) {
          if (!isExpectedError(e, expects)) {
            throw e;
          }

          resolve(createResult(null, e));
        });
      });
    }

    return createResult(result);
  } catch (e) {
    if (!isExpectedError(e, expects)) {
      throw e;
    }

    return createResult(null, e);
  }
};

rescue.isFailure = function (result) {
  return result.error != null;
};

rescue.isSuccess = function (result) {
  return result.error == null;
};

exports.rescue = rescue;
